import { ReactNode, createContext, useContext } from "react";
import { useGetAreaListingData } from "./hooks/useGetAreaListingData";
import { CountyData } from "./types";

interface DataContextProps {
  data: CountyData[] | [];
  countyNames: string[];
}

interface DataProviderProps {
  children: ReactNode;
}

export const CaravanDataContext = createContext<DataContextProps>({
  data: [],
  countyNames: [],
});

// data consists of an upper level array,
// containing objects,
// the objects have region names which are an array,
// those arrays have objects which have county names,
// the counties have objects which are caravans with only beds and prices
export const DataProvider = ({ children }: DataProviderProps) => {
  const { data } = useGetAreaListingData();

  const areaListingData = data ?? [];

  const countyNames: string[] = areaListingData
    ?.flatMap((region: any) => Object.keys(region))
    .map((name) => name.toLowerCase())
    .sort();

  return (
    <CaravanDataContext.Provider value={{ data: areaListingData, countyNames }}>
      {children}
    </CaravanDataContext.Provider>
  );
};

export const useCaravanDataContext = () => {
  const context = useContext(CaravanDataContext);
  if (!context) {
    throw new Error("useFormContext must be used within a FormProvider");
  }
  return context;
};
